import { handleCourseFiltering } from 'src/components/Filter/ExpandedMenu/events'
import { setFilterBody } from 'src/redux/slices/eLearning/collection'

export const handleCheckboxChange = (e, filterBody) => (dispatch) => {
  const payload = handleCourseFiltering(e, filterBody)
  dispatch(setFilterBody(payload))
}
